import React from "react";
import PropTypes from "prop-types";
import useMediaQuery from "../../hooks/useMediaQuery";
import Image from "../Image";
import "./bannerSection.scss";
import CheckList from "../CheckList/CheckList";

const BannerSection = ({
  data,
  signUpLink,
  mobileSrc,
  webSrc,
  supertitle,
  title,
}) => {
  const isMobile = useMediaQuery("(max-width: 640px)");

  return (
    <div className="banner-section">
      <div className="banner-content">
        <div className="item left-item">
          <p className="text-sm font-semibold text-cf-white pl-5 mb-[10px] uppercase relative before:bg-cf-green before:h-[10px] before:w-[10px] before:absolute before:top-[4px] before:left-[4px]">
            {supertitle}
          </p>
          <div className="text-lg md:text-xl font-semibold mb-[28px] text-cf-white font-heading max-w-[850px] w-full">
            {title}
          </div>
          <CheckList
            data={data}
            customText="text-cf-white font-normal"
            className="mb-[28px]"
          />
          <div>
            <a
              className="button button-green md:px-[24.5px] w-full md:w-[178px]"
              href={signUpLink}>
              Sign Up <span className="chevron !mb-0" />
            </a>
          </div>
        </div>
        <div className="item right-item">
          {isMobile ? (
            <Image
              src={mobileSrc}
              alt="mobileIllustration"
              width="343"
              height="341"
              className="mobile-icon"
            />
          ) : (
            <Image
              src={webSrc}
              alt="desktopIllustration"
              width="610"
              height="467"
              className="desktop-icon"
            />
          )}
        </div>
      </div>
    </div>
  );
};

BannerSection.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  signUpLink: PropTypes.string.isRequired,
  mobileSrc: PropTypes.string.isRequired,
  webSrc: PropTypes.string.isRequired,
  supertitle: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default BannerSection;
